import flatten from "lodash/flatten";
import { parseSeries } from "views/logic/aggregationbuilder/Series";
import { convertValueToBaseUnit, getPrettifiedValue } from "views/components/visualizations/utils/unitConverters";
import { getYAxisSide } from "views/components/visualizations/utils/chartLayoutGenerators";
import { NO_FIELD_NAME_SERIES } from "views/components/visualizations/Constants";
import formatValueWithUnitLabel from "views/components/visualizations/utils/formatValueWithUnitLabel";
const getThresholdShapes = ({
  series,
  widgetUnits,
  fieldNameToAxisNameMapper,
  mapperAxisNumber,
  theme
}) => {
  const thresholds = series == null ? void 0 : series.map((curSeries) => {
    var _a, _b;
    const { field } = (_a = parseSeries(curSeries.function)) != null ? _a : {};
    const seriesUnit = widgetUnits.getFieldUnit(field);
    return (_b = curSeries.config.thresholds) == null ? void 0 : _b.map(({ color, value, name }) => {
      var _a2, _b2;
      const conversionParams = seriesUnit && seriesUnit.isDefined ? { abbrev: seriesUnit == null ? void 0 : seriesUnit.abbrev, unitType: seriesUnit == null ? void 0 : seriesUnit.unitType } : null;
      const baseUnitValue = conversionParams ? convertValueToBaseUnit(Number(value), conversionParams).value : value;
      const yref = (_a2 = fieldNameToAxisNameMapper == null ? void 0 : fieldNameToAxisNameMapper[field != null ? field : NO_FIELD_NAME_SERIES]) != null ? _a2 : "y";
      const prettified = conversionParams ? getPrettifiedValue(Number(value), conversionParams) : null;
      const formattedValueWithUnitLabel = prettified ? formatValueWithUnitLabel(prettified == null ? void 0 : prettified.value, prettified.unit.abbrev, 0) : value;
      const seriesName = curSeries.config.name || curSeries.function;
      const axisCount = (_b2 = mapperAxisNumber[seriesName]) != null ? _b2 : 1;
      const shape = {
        type: "line",
        x0: 0,
        x1: 1,
        y0: baseUnitValue,
        y1: baseUnitValue,
        xref: "paper",
        yref,
        name,
        line: {
          color
        }
      };
      const bgColor = theme.utils.opacify(color, 0.6);
      const contrastColor = theme.utils.readableColor(bgColor);
      const side = getYAxisSide(axisCount);
      const annotation = {
        x: side === "left" ? 0 : 1,
        y: baseUnitValue,
        xref: "paper",
        yref,
        text: `${name} (${formattedValueWithUnitLabel})`,
        showarrow: false,
        xanchor: side,
        yanchor: "bottom",
        align: side,
        font: { color: contrastColor, size: 12 },
        xshift: 0,
        yshift: 0,
        bgcolor: bgColor,
        bordercolor: bgColor,
        borderpad: 3
      };
      return { shape, annotation };
    });
  });
  const res = flatten(thresholds).filter((threshold) => !!(threshold == null ? void 0 : threshold.shape));
  return {
    shapes: res.map(({ shape }) => shape),
    annotations: res.map(({ annotation }) => annotation)
  };
};
export default getThresholdShapes;
